<div class="empty-state">
  <mat-icon>currency_rupee_circle</mat-icon>
  <p>Reports coming soon </p>
</div>
